import { render, staticRenderFns } from "./limitCompConfig.vue?vue&type=template&id=5c14b742"
import script from "./limitCompConfig.vue?vue&type=script&lang=js"
export * from "./limitCompConfig.vue?vue&type=script&lang=js"
import style0 from "./limitCompConfig.vue?vue&type=style&index=0&id=5c14b742&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports